export const _en = {
    resourceCategories: {
        layer: {
            libelle: "Resources categories"
        },
        modal: {
            add: {
                title: "Add category"
            },
            del: {
                title: "Delete category"
            },
            update: {
                title: "Update category"
            }
        }
    },
    resourceTypes: {
        layer: {
            libelle: "Resources types"
        },
        modal: {
            add: {
                title: "Add type"
            },
            del: {
                title: "Delete type"
            },
            update: {
                title: "Update type"
            }
        }
    },
    resources: {
        layer: {
            libelle: "Named resources"
        },

        buttons: {
            add: {
                label: "Add named resource"
            },
            del: {
                label: "Delete named resource"
            }
        },
        dialog: {
            add: {
                title: "Add new named resource"
            },
            duplicate: {
                humanResourceAFCA: {
                    label: ""
                },
                humanResourceATO: {
                    label: " "
                },
                MaterialResource: {
                    label: "  "

                }
            },
            delete: "Supprimer les ressources:"
        },
        deletedCheckBox: {
            label: "Display deleted data"
        }
    },
    resourceQualification: {
        layer: {
            libelle: "Features",
            component: {
                placeholder: "Add features",
                actionBarLabel: "Delete",
                associationButton: "Associate"
            }
        }
    },
    resourceSkill: {
        layer: {
            libelle: "Associate skills",
            component: {
                placeholder: "Select a skill",
                selectPlaceholder: {
                    human: "Add skill",
                    material: "Add Feature"
                },
                actionBarLabel: "Action(s)",
                associationButton: "Associate"
            }
        },
        columns: {
            startDate: {
                libelle: "Start date",
                errors: {
                    required: "Start date is mandatory",
                    dateValidation: "The start date must be earlier than the end date"
                }
            },
            finishDate: {
                libelle: "Finish date",
                errors: {
                    dateValidation: "The start date must be earlier than the end date"
                }
            }
        }
    },
    resourceAvaibility: {
        layer: {
            libelle: "",
            component: {
                placeholder: "",
                actionBarLabel: "",
                associationButton: ""
            }
        }
    },
    timeTable: {
        layer: {
            libelle: "",
            component: {
                placeholder: "",
                actionBarLabel: "",
                associationButton: ""
            }
        },
        duplicatedEntry: {
            label: "This timetable is already present."
        },
        NeedStartDate: {
            label: "You need to define a start date before adding another timetable."
        },
        NeedEndDate: {
            label: "You need to define a finish date before adding another timetable."
        },
        StartBeforeEnd: {
            label: "The start date must be before finish date."
        },
        EndAfterStart: {
            label: "The finish date must be after start date."
        },
        ChangedToMonday: {
            label: "The start date has been changed to monday of the selected week."
        },
        ChangedToSunday: {
            label: "The finish date has been changed to sunday of the selected week."
        },
        regenerateBtn: {
            tooltip: "Regenerate resource availabilities"
        },
        dateOverLap: {
            label: "The date entered overlaps with another time grid"
        },
        requiredStartDate: {
            label: "The start date of the assignment is mandatory"
        },
        requiredFinishDate: {
            label: "Start date is required"
        },
        dateNotPossible: {
            label: "The chosen date does not have possible date intervals"
        },
        startDateNotValid: {
            label: "The start date entered is not valid for the period from {{startDateValidity}} to {{finishDateValidity}}"
        },
        finishDateNotValid: {
            label: "The finish date entered is not valid for the period from {{startDateValidity}} to {{finishDateValidity}}"
        },
        hiddenContainer: {
            firstLine: "At least one of the selected resources is an anonymous resource.",
            secondLine: "An anonymous resource does not have a timetable grid and is always considered present"
        }
    },
    resourceTimetable: {
        layer: {
            libelle: "Time sheet",
            component: {
                placeholder: "Choose a timesheet",
                actionBarLabel: "Delete",
                associationButton: "Associate"
            }
        },
        columns: {
            startDate: {
                libelle: "Start date",
                errors: {
                    required: "The start date field is required ",
                    dateValidation: "The start date must be before the end date"
                }
            },
            finishDate: {
                libelle: "Finish date",
                errors: {
                    dateValidation: "The finish date must be after the start date"
                }
            },
            weekNumber: {
                libelle: "week number",
                errors: {
                    weekNumberValidation: "the number of the week must be smaller than the number of weeks existing in the timetable "
                }
            }
        }
    },
    resourcesTimesSettings: {
        layer: {
            libelle: "Time setting"
        }
    },

    statusModal: {
        title: "Scheduled resource",
        description: "You're going to change the status to inactive for a scheduled resource. Do you wan't to continue?",
        ok: "Deactivate",
        cancel: "Cancel"
    },
    saveError: {
        title: "Error",
        description: "An error occurred, the data has not been saved."
    }

};

export const _fr = {
    resourceCategories: {
        layer: {
            libelle: "Catégories de ressources"
        },
        modal: {
            add: {
                title: "Ajout d'une catégorie de ressources"
            },
            del: {
                title: "Supprimer une catégorie de ressources"
            },
            update: {
                title: "Modifier une catégorie de ressources"
            }
        }
    },
    resourceTypes: {
        layer: {
            libelle: "Types de ressources"
        },
        modal: {
            add: {
                title: "Ajout d'un type de ressources"
            },
            del: {
                title: "Supprimer un type de ressources"
            },
            update: {
                title: "Modifier un type de ressources"
            }
        }
    },
    resources: {
        layer: {
            libelle: "Ressources"
        },
        buttons: {
            add: {
                label: "Ressource"
            },
            del: {
                label: "Supprimer"
            }
        },
        dialog: {
            add: {
                title: "Ajout d'une ressource"
            },
            duplicate: {
                humanResourceAFCA: {
                    label: "En dupliquant cette ressource, vous dupliquez également ses compétences ainsi que ses contraintes de disponibilité et grille horaire si elles existent."
                },
                humanResourceATO: {
                    label: "En dupliquant cette ressource, vous dupliquez également ses compétences ainsi que ses contraintes de disponibilité si elles existent."
                },
                materialResource: {
                    label: "En dupliquant cette ressource, vous dupliquez également ses qualifications ainsi que ses contraintes de disponibilité si elles existent."

                }
            },
            delete: "Supprimer les ressources:"
        },
        deletedCheckBox: {
            label: "Afficher les données archivées"
        }
    },
    resourceSkill: {
        layer: {
            libelle: "Compétences",
            component: {
                placeholder: "Sélectionner une compétence",
                selectPlaceholder: {
                    human: "Ajouter une compétence",
                    material: "Ajouter une caractéristique"
                },
                actionBarLabel: "Suppression",
                associationButton: "Associer"
            }
        },
        columns: {
            startDate: {
                libelle: "Date de début",
                errors: {
                    required: "Le champ \"Date de début\" est obligatoire",
                    dateValidation: "La date de début doit être antérieure à la date de fin"
                }
            },
            finishDate: {
                libelle: "Date de fin",
                errors: {
                    dateValidation: "La date de début doit être antérieure à la date de fin"
                }
            }
        }
    },
    resourceQualification: {
        layer: {
            libelle: "Caractéristiques",
            component: {
                placeholder: "Sélectionner une qualification",
                actionBarLabel: "Suppression",
                associationButton: "Associer"
            }
        },
        columns: {
            startDate: {
                libelle: "Date de début",
                errors: {
                    required: "Le champ \"Date de début\" est obligatoire",
                    dateValidation: "La date de début doit être antérieure à la date de fin"
                }
            },
            finishDate: {
                libelle: "Date de fin",
                errors: {
                    dateValidation: "La date de début doit être antérieure à la date de fin"
                }
            }
        }
    },
    resourceAvaibility: {
        layer: {
            libelle: "Horaires de disponibilité",
            component: {
                placeholder: "Sélectionner une horaire de disponibilité",
                actionBarLabel: "Suppression",
                associationButton: "Associer"
            }
        }
    },
    timeTable: {
        layer: {
            libelle: "",
            component: {
                placeholder: "",
                actionBarLabel: "",
                associationButton: ""
            }
        },
        duplicatedEntry: {
            label: "La grille horaire est déjà présente."
        },
        NeedStartDate: {
            label: "Vous devez renseigner une date de début de validité pour la grille présente avant d'en ajouter une nouvelle."
        },
        NeedEndDate: {
            label: "Vous devez renseigner une date de fin de validité pour la grille présente avant d'en ajouter une nouvelle."
        },
        StartBeforeEnd: {
            label: "La date de fin devrait être ultérieure à la date de début."
        },
        EndAfterStart: {
            label: "La date de début devrait être antérieure à la date de fin."
        },
        ChangedToMonday: {
            label: "La date a été modifiée pour correspondre au lundi de la semaine choisie."
        },
        ChangedToSunday: {
            label: "La date a été modifiée pour correspondre au dimanche de la semaine choisie."
        },
        regenerateBtn: {
            tooltip: "Regénerer les disponibilités de la ressource"
        },
        dateOverLap: {
            label: "Deux grilles horaires ne peuvent pas se chevaucher. La date renseignée est invalide."
        },
        requiredStartDate: {
            label: "La date de début d'affectation est obligatoire"
        },
        requiredFinishDate: {
            label: "La date de fin d'affectation est obligatoire"
        },
        dateNotPossible: {
            label: "Cette grille horaire ne peut être affectée à cette ressource, car d'autres grilles sont déjà affectées sur sa période de validité du {{startDateValidity}} à {{finishDateValidity}}"
        },
        startDateNotValid: {
            label: "La date de début renseignée n'est pas valide pour la période de la gille horaire {{startDateValidity}} à {{finishDateValidity}}"
        },
        finishDateNotValid: {
            label: "La date de fin renseignée n'est pas valide pour la période de la gille horaire {{startDateValidity}} à {{finishDateValidity}}"
        },
        hiddenContainer: {
            firstLine: "Au moins une des ressources sélectionnées est une ressource anonyme.",
            secondLine: "Une ressource anonyme ne dispose pas de grille horaires et est considérée toujours présente"
        }
    },
    resourceTimetable: {
        layer: {
            libelle: "Grille horaire",
            component: {
                placeholder: "Sélectionner une grille horaire",
                actionBarLabel: "Suppression",
                associationButton: "Associer"
            }
        },
        columns: {
            startDate: {
                libelle: "Date de début",
                errors: {
                    required: "Le champ \"Date de début\" est obligatoire",
                    dateValidation: "La date de début doit être antérieure à la date de fin",
                    alertMondayDay: "La date de début doit être un lundi",
                    alertBetwennStartAndFinshDateOfTimeSheet: "Choisir une date entre date debut et fin de la grille horaire",
                    alertLessThan: "La date de début de la nouvelle grille horaire doit être plus récente que la date de début de la précédente grille horaire"
                }
            },
            finishDate: {
                libelle: "Date de fin",
                errors: {
                    dateValidation: "La date de début doit être antérieure à la date de fin"
                }
            },
            weekNumber: {
                libelle: "Numéro de la semaine",
                errors: {
                    weekNumberValidation: "Le numéro de la semaine doit être inférieur au nombre de semaine existant dans la grille horaire"
                }
            }
        }
    },
    resourcesTimesSettings: {
        layer: {
            libelle: "Calage horaire"
        }
    },
    statusModal: {
        title: "La ressource est planifiée",
        description: "Vous allez rendre inactive une ressource planifiée. Voulez-vous désactiver la ressource ?",
        ok: "Désactiver",
        cancel: "Annuler"
    },
    saveError: {
        title: "Erreur",
        description: "Une erreur est survenue, l'opération n'a pas été enregistrée"
    }

};